import VotingCard from '../components/voting/VotingCard'

export default function Main() {
  return (
    <main className="w-full max-w-full overflow-x-hidden">
      <div className="container mx-auto px-3 py-2 max-w-7xl">
        <VotingCard />
      </div>
    </main>
  )
}

